import { TMCClientParameters } from '../../tmc-common/tmc-client-parameters';
import { TranslationService } from '@sdbn/common';
import { Injectable } from '@angular/core';
import { ConfigurationService } from '@sdbn/appclient';

@Injectable({
  providedIn: 'root'
})
export class TransportFormatterService {

  constructor(
    private translationService: TranslationService,
    private configurationService: ConfigurationService) {

  }

  public formatTransportIdentifier(identifier: string, transportScope: any): string {

    if (this.configurationService.isEnabled(TMCClientParameters.P_VISITS_ATTACH_DETACH_ENABLED, false)) {
      const i18n = this.translationService.translate('tmc.transport-formatter.transport-scope.' + transportScope);
      if (i18n) {
        return i18n + ' - ' + identifier;
      }
    }

    return identifier;
  }

}
